// extracted by mini-css-extract-plugin
export default {"container":"Fk-z","blurb":"Gk-z","links":"Hk-z"};